<template>
  <v-dialog v-model="loader" :scrim="false" persistent width="auto" content-class="overview-loader">
    <div class="overview-loader__inner">
      <v-progress-circular
        indeterminate
        :size="50"
        color="#857FD3"
      />
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoaderPopup',
  props: {
    loader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style  lang="scss">
.v-dialog.overview-loader {
  background-color: transparent;
  box-shadow: none;

  .overview-loader__inner {
    padding: 20px;
    overflow: hidden;
  }
}
</style>
